import styles from "components/sections/search/NoSearchResult.module.scss";
import FullButton from "components/buttons/FullButton";
import {useContext, useEffect, useState} from "react";
import UserContext from "context/AuthContext";
import {getCreatorRoute, getStoreProductListRoute, myPageRoute, newPostRoute, storeRoute} from "common/const";
import Link from "next/link";
import utilStyles from "styles/utils.module.scss";
import checkoutStyles from "pages/store/orders/[ordNum]/checkout.module.scss";
import TextInput from "components/input/TextInput";
import {customConfirm, shuffle} from "common/utils";
import HorizontalProducts from "components/layout/store/products/HorizontalProducts";
import {Axios} from "api";
import {captureException, captureMessage} from "@sentry/nextjs";
import HorizontalBrands from "components/layout/store/brands/HorizontalBrands";
import {KEY_SELL_COUNT} from "pages/store/products";
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';




export const NoPaletteSearchResult = (props) => {
    const {t} = useTranslation();
    const {query} = props;

    const onClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'NoPaletteSearchResultGoToNewPaletteClick'
        );
    };

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewNoPaletteSearchResult',
            {query},
        );
    }, []);

    return (
        <div className={styles.root}>
            <div className={styles.container} style={{paddingTop: 184}}>
                <span className={styles.icon}>🎨</span>
                <span className={styles.text}>
                    <Trans
                        i18nKey="sections-search-NoSearchResult:NoPaletteSearchResult.noResult"
                        components={[<span className={styles.color}>{query}</span>]}
                        values={{query}}
                    /><br/>
                    {t('sections-search-NoSearchResult:NoPaletteSearchResult.writePalette')}
                </span>
                <Link href={newPostRoute}>
                    <a className={styles.button} onClick={onClick}>
                        <FullButton height={40}>
                            <span className={styles.buttonText}>
                                {t('sections-search-NoSearchResult:NoPaletteSearchResult.writeButton')}
                            </span>
                        </FullButton>
                    </a>
                </Link>
            </div>
        </div>
    )
};

export const NoSellerShopSearchResult = (props) => {
    const {query} = props;
    const user = useContext(UserContext).user;
    const {t} = useTranslation('sections-search-NoSearchResult');

    const hasSellerShop = Boolean(user?.grade_info);

    const onClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'NoSellerShopSearchResultGoToSellerShopClick'
        );
    };

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewNoSellerShopSearchResult',
            {query},
        );
    }, []);

    return (
        <div className={styles.root}>
            <div className={styles.container} style={{paddingTop: 184}}>
                <span className={styles.icon}>#</span>
                <span className={styles.text}>
                    <Trans
                        i18nKey="sections-search-NoSearchResult:NoSellerShopSearchResult.noResult"
                        components={[<span className={styles.color}>{query}</span>]}
                        values={{query}}
                    /><br/>
                    {!hasSellerShop && t('sections-search-NoSearchResult:NoSellerShopSearchResult.createFirst')}
                </span>
                {
                    !hasSellerShop &&
                    <Link href={hasSellerShop ? getCreatorRoute(user.code) : myPageRoute}>
                        <a className={styles.button} style={{width: 185}} onClick={onClick}>
                            <FullButton height={40}>
                                <span className={styles.buttonText}>
                                    {t('sections-search-NoSearchResult:NoSellerShopSearchResult.createButton')}
                                </span>
                            </FullButton>
                        </a>
                    </Link>
                }
            </div>
        </div>
    )
};

const NoSearchResult = (props) => {
    const {query} = props;
    const {t} = useTranslation('sections-search-NoSearchResult');

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewNoSearchResult',
            {query},
        );
    }, []);

    return (
        <div className={styles.container}>
            <span className={styles.text}>
                <Trans
                    i18nKey="sections-search-NoSearchResult:NoSearchResult.noResult"
                    components={[<span className={styles.color}>{query}</span>]}
                    values={{query}}
                />
                <br/>
                {t('NoSearchResult.enterAccurate')}
            </span>
        </div>
    )
};
export const NoAllSearchResult = (props) => {
    const {query} = props;
    const {t} = useTranslation('sections-search-NoSearchResult');

    const onClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'NoAllSearchResultGoToButtonClick'
        );
    };

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewNoAllSearchResult',
            {query},
        );
    }, [query]);

    return (
        <>
            <NoSearchResult query={query}/>
            <div className={utilStyles.mobileBorder}/>
            <div className={styles.container} style={{paddingTop: 24}}>
                <span className={styles.icon} style={{marginBottom: 0, height: 48}}>🥇</span>
                <span className={styles.text}>
                    <span className={styles.boldText}>{t('NoAllSearchResult.popularProducts')}</span>
                </span>
                {
                    <Link href={getStoreProductListRoute(KEY_SELL_COUNT)}>
                        <a className={styles.button} style={{width: 164, marginTop: 16}} onClick={onClick}>
                            <FullButton height={40}>
                                <span className={styles.buttonText}>{t('NoAllSearchResult.viewPopular')}</span>
                            </FullButton>
                        </a>
                    </Link>
                }
            </div>
        </>
    );
};

export const StoreEntranceRequestForm = (props) => {
    const [text, setText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const {t} = useTranslation('sections-search-NoSearchResult');

    const submit = () => {
        if (text && text.length > 0) {
            typeof mixpanel !== 'undefined' && mixpanel.track(
                'StoreEntranceRequestFormSubmit',
                {
                    text,
                }
            );
            sendRequest(text);
        }
    };
    const sendRequest = async (query) => {
        setIsLoading(true);
        let failed = false;
        try {
            const res = await Axios.post('v1/search/request-store-entrance', {query});
            if (res.status < 400) {
                customConfirm(
                    <span className={styles.formConfirmText}>
                        {t('StoreEntranceRequestForm.successMessage')}
                    </span>,
                    t('StoreEntranceRequestForm.confirm'),
                    null,
                    () => {
                    },
                    () => {
                    },
                );
            } else {
                failed = true;
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            failed = true;
            captureException(e);
        } finally {
            if (failed) {
                customConfirm(
                    <span className={styles.formConfirmText}>
                        {t('StoreEntranceRequestForm.errorMessage')}
                    </span>,
                    t('StoreEntranceRequestForm.confirm'),
                    null,
                    () => {
                    },
                    () => {
                    },
                );
            }
            setIsLoading(false);
            setText('');
        }
    };

    return (
        <div className={styles.formContainer}>
            <span className={styles.formDescription}>
                {t('StoreEntranceRequestForm.noProduct')} <br/>
                {t('StoreEntranceRequestForm.registerProduct')}
            </span>
            <div className={styles.formInputContainer}>
                <div className={checkoutStyles.inputWrapper}>
                    <TextInput
                        error={false}
                        placeholder={t('StoreEntranceRequestForm.placeholder')}
                        readonly={false}
                        value={text}
                        onChange={(e) => setText(e)}
                    />
                </div>
                <div className={styles.formButtonWrapper} onClick={submit}>
                    <FullButton height={44} fontSize={16} disabled={isLoading || !(text && text.length > 0)}>
                        {t('StoreEntranceRequestForm.submitButton')}
                    </FullButton>
                </div>
            </div>
        </div>
    )
}

export const NoStoreSearchResult = (props) => {
    const {query} = props;
    const {t} = useTranslation('sections-search-NoSearchResult');
    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetchPopularProducts();
    }, []);

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewNoStoreSearchResult',
            {query},
        );
    }, []);

    const fetchPopularProducts = async () => {
        try {
            const res = await Axios.get('v1/curation/search_no_result_product_recommendation/');
            if (res.status < 400) {
                const products = shuffle(res.data.item_list).slice(0, 10);
                setProducts(products);
            } else {
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            captureException(e);
        } finally {
        }
    };

    const handleProductClick = (product, itemIdx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'NoStoreSearchResultProductClick',
            {
                productId: product.id,
                productName: product.name,
                productBrand: product.brand,
                itemIdx: itemIdx,
            }
        );
    };

    return (
        <>
            <NoSearchResult query={query}/>
            <div className={utilStyles.mobileBorder}/>
            <StoreEntranceRequestForm />
            {
                products && products.length > 0 &&
                <>
                    <div className={utilStyles.mobileBorder}/>
                    <div className={styles.sectionContainer}>
                        <span className={styles.sectionTitle}>{t('NoStoreSearchResult.recommendation')}</span>
                        <div className={styles.productListContainer}>
                            <HorizontalProducts
                                products={products}
                                onProductClick={handleProductClick}
                            />
                        </div>
                    </div>
                </>
            }
            <div className={styles.bottomPadding} />
        </>
    );
};
export const NoBrandSearchResult = (props) => {
    const {query} = props;
    const {t} = useTranslation('sections-search-NoSearchResult');
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        fetchPopularBrands();
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewNoBrandSearchResult',
            {query},
        );
    }, []);

    const handleBrandClick = (brand, itemIdx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'NoBrandSearchResultBrandClick',
            {
                brand: brand.name,
                itemIdx: itemIdx,
            }
        );
    };

    const fetchPopularBrands = async () => {
        try {
            const res = await Axios.get('v1/curation/search_no_result_brand_recommendation/');
            if (res.status < 400) {
                const brands = shuffle(res.data.item_list).slice(0, 10);
                setBrands(brands);
            } else {
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            captureException(e);
        } finally {
        }
    };

    return (
        <>
            <NoSearchResult query={query}/>
            <div className={utilStyles.mobileBorder}/>
            <StoreEntranceRequestForm />
            {
                brands && brands.length > 0 &&
                <>
                    <div className={utilStyles.mobileBorder}/>
                    <div className={styles.sectionContainer}>
                        <span className={styles.sectionTitle}>{t('NoBrandSearchResult.recommendation')}</span>
                        <div className={styles.productListContainer}>
                            <HorizontalBrands brands={brands} onBrandClick={handleBrandClick}/>
                        </div>
                    </div>
                </>
            }
            <div className={styles.bottomPadding} />
        </>
    );
};

export default NoSearchResult;
